import { DEFAULT_PAGE, ITEMS_PER_PAGE } from 'core/constants/platform.constants';
import type { IGetDownloadReportListResponse } from 'core/model/interfaces/downloads-uploads';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../downloads.constants';
import type { IDownloadsState } from '../downloads.types';

export const fetchAllDownloadReportsByReportType = createAppAsyncThunk<IGetDownloadReportListResponse>(
  `${SLICE_NAMESPACE}/fetchAllDownloadReportsByReportType`,
  async (_, store) => {
    try {
      const state = store.getState();

      const { downloads } = state;

      const { filters, list } = downloads;

      const { reportType } = filters;

      const { pagination } = list;

      const response = await apiService.downloads.getDownloadReportListByReportType({
        page: pagination.currentPage || DEFAULT_PAGE,
        itemsPerPage: pagination.itemsPerPage || ITEMS_PER_PAGE,
        reportType,
      });

      return response;
    } catch (error) {
      notificationService.global.error('Falló al cargar la lista de descargas.');

      throw error;
    }
  },
);

export const fetchAllDownloadReportsByReportTypeReducer: TSliceExtraReducer<IDownloadsState> = builder =>
  builder
    .addCase(fetchAllDownloadReportsByReportType.pending, state => {
      state.list.loading = true;
    })
    .addCase(fetchAllDownloadReportsByReportType.rejected, state => {
      state.list.loading = false;
      state.list.downloads = [];
    })
    .addCase(fetchAllDownloadReportsByReportType.fulfilled, (state, action) => {
      state.list.loading = false;
      state.list.downloads = action.payload.reports;
      state.list.pagination = action.payload.pagination;
    });
